import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-tenants-mgmt',
    templateUrl: './tenants-mgmt.component.html',
    styleUrls: ['./tenants-mgmt.component.scss'],
    standalone: false
})
export class TenantsMgmtComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
